<template>
  <div>
    <v-dialog 
      :value="value" 
      @input="$emit('input')" 
      transition="fade-transition" 
      scrollable 
      width="800px" >
      <v-card>
          <!-- <v-toolbar color="elevation-2">
            <v-toolbar-title class="headline">View Influencer</v-toolbar-title>
            
          </v-toolbar> -->
        <v-card-title class="card-title-background">
          View Influencer
            <v-spacer></v-spacer>
            <v-btn icon @click="close">
              <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text style="overflow: hidden;margin-top: 10px;min-height: 35px;">
          <div>
            <v-row class="text-right">
              <v-col class="pb-2" cols="12" sm="12" md="12" lg="12">
                <v-btn color="secondary" small @click="changeModeCustom('edit')" v-if="isViewMode">
                  <v-icon v-on="on" small>edit</v-icon>
                  Edit
                </v-btn>
                <v-btn color="error" small @click="changeModeCustom('view')" v-if="isEditMode">
                  <v-icon v-on="on" small>close</v-icon>
                  Cancel Edit
                </v-btn>
                <!-- <v-btn color="green" small @click="processEdit" v-if="isEditMode">Save changes</v-btn> -->
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <!-- Popup content -->
          <!-- <v-container fluid> -->
          <v-card-text style="height: 700px;margin-top:20px;">
            <div v-show="isViewMode">
              <v-expansion-panels v-model="openExpansion" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">
                    Contact Information
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Instagram Handle</label>
                        <social-handle
                          :isInstagram="influencer.instagram ? true : false"
                          :instagramHandle="influencer.instagram ? influencer.instagram.instagramHandle : ''"
                          v-if="influencer.instagram"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>TikTok Handle</label>
                        <social-handle
                          :isTikTok="influencer.tiktok ? true : false"
                          :tiktokHandle="influencer.tiktok ? influencer.tiktok.tiktokHandle : ''"
                          v-if="influencer.tiktok"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Youtube Handle</label>
                        <social-handle
                          :isYoutube="influencer.youtube ? true : false"
                          :youtubeHandle="influencer.youtube ? influencer.youtube.youtubeHandle : ''"
                          v-if="influencer.youtube"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Facebook Handle</label>
                        <social-handle
                          :isFacebook="influencer.facebook ? true : false"
                          :facebookHandle="influencer.facebook ? influencer.facebook.handle : ''"
                          v-if="influencer.facebook"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>XHS Handle</label>
                        <social-handle
                          :isXiaohongshu="influencer.xiaohongshu ? true : false"
                          :xiaohongshuHandle="influencer.xiaohongshu ? influencer.xiaohongshu.xhsHandle : ''"
                          :xiaohongshuFullName="influencer.xiaohongshu ? influencer.xiaohongshu.xhsFullname : ''"
                          v-if="influencer.xiaohongshu"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>LinkedIn Handle</label>
                        <social-handle
                          :isLinkedIn="true"
                          :linkedinHandle="influencer.linkedin ? influencer.linkedin.linkedinHandle : ''"
                          v-if="influencer.linkedin && influencer.linkedin.linkedinHandle"
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>X (Twitter) Handle</label>
                        <social-handle
                          :isTwitter="true"
                          :twitterHandle="influencer.twitter ? influencer.twitter.twitterHandle : ''"
                          v-if="influencer.twitter && influencer.twitter.twitterHandle"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Fullname</label>
                        <div v-if="influencer.fullName">{{influencer.fullName}}</div>
                        <div v-else>
                          <div v-if="influencer.tiktok">{{ (influencer.tiktok.tiktokFullname ? influencer.tiktok.tiktokFullname : '-') }}</div>
                          <div v-else-if="influencer.youtube">{{ (influencer.youtube.youtubeFullname ? influencer.youtube.youtubeFullname : '-') }}</div>
                          <div v-else-if="influencer.facebook">{{ (influencer.facebook.name ? influencer.facebook.name : '-') }}</div>
                          <div v-else-if="influencer.xiaohongshu">{{ (influencer.xiaohongshu.xhsFullname ? influencer.xiaohongshu.xhsFullname : '-') }}</div>
                          <div v-else-if="influencer.linkedin">{{ (influencer.linkedin.linkedinFullname ? influencer.linkedin.linkedinFullname : '-') }}</div>
                          <div v-else-if="influencer.twitter">{{ (influencer.twitter.twitterFullname ? influencer.twitter.twitterFullname : '-') }}</div>
                          <div v-else>{{ influencer.instagram ? (influencer.instagram.instagramFullname ? influencer.instagram.instagramFullname : '-') : '-' }}</div>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Email</label>
                        <div>{{ (influencer.email ? influencer.email : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Contact Number</label>
                        <div>{{ (influencer.phone ? influencer.phone : '-') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>What is your occupation?</label>
                        <div>
                          {{inputedRates.occupation || '-'}}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">
                    Billing Information
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Bank name</label>
                        <div>{{ (influencer.bankName ? influencer.bankName : '-') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Swift code</label>
                        <div>{{ (influencer.swiftCode ? influencer.swiftCode : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Bank account</label>
                        <div>{{ (influencer.bankAccount ? influencer.bankAccount : '-') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Fullname as per Bank Account</label>
                        <div>{{ (influencer.fullName ? influencer.fullName : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Country</label>
                        <div>{{ (influencer.country ? influencer.country: '-') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Street address</label>
                        <div>{{ (influencer.mailingAddress ? influencer.mailingAddress : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Postal Code</label>
                        <div>{{ (influencer.postalCode ? influencer.postalCode : '-') }}</div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">
                    Your Rates <span style="font-size:10px;margin-left:5px;">(in SGD per item)</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
                        <label>Influencer Handle</label>
                        <social-handle
                          :isInstagram="true"
                          :instagramHandle="inputedRates.instagramHandle"
                          v-if="inputedRates.instagramHandle"
                        />
                        <div v-if="!inputedRates.instagramHandle">-</div>
                      </v-col>
                      <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
                        <label>Tiktok Handle</label>
                        <social-handle
                          :isTikTok="true"
                          :tiktokHandle="inputedRates.tiktokHandle"
                          v-if="inputedRates.tiktokHandle"
                        />
                        <div v-if="!inputedRates.tiktokHandle">-</div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-row>
                          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
                            <v-simple-table dense>
                              <template v-slot:default>
                                <!-- <thead>
                                  <tr>
                                    <th class="text-left">Platform</th>
                                    <th class="text-left">URL</th>
                                    <th class="text-left">Rate</th>
                                  </tr>
                                </thead> -->
                                <tbody>
                                  <tr>
                                    <td class="pl-0">IG Story</td>
                                    <td><strong>{{ inputedRates.igStory || '-'  }}</strong> <span v-if="inputedRates.igStory">{{ inputedRates.igStoryCurrency || 'SGD' }}</span></td>
                                  </tr>
                                  <tr>
                                    <td class="pl-0">IG Post</td>
                                    <td><strong>{{ inputedRates.igPost || '-'  }}</strong> <span v-if="inputedRates.igPost">{{ inputedRates.igPostCurrency || 'SGD' }}</span></td>
                                  </tr>
                                  <tr>
                                    <td class="pl-0">IG Carousel</td>
                                    <td><strong>{{ inputedRates.igCarousel || '-'  }}</strong> <span v-if="inputedRates.igCarousel">{{ inputedRates.igCarouselCurrency || 'SGD' }}</span></td>
                                  </tr>
                                  <!-- <tr>
                                    <td class="pl-0">IG Video</td>
                                    <td><strong>{{ inputedRates.igVideo || '-'  }}</strong> <span v-if="inputedRates.igVideo">$ SGD</span></td>
                                  </tr> -->
                                  <tr>
                                    <td class="pl-0">IG Reel</td>
                                    <td><strong>{{ inputedRates.igReel || '-'  }}</strong> <span v-if="inputedRates.igReel">{{ inputedRates.igReelCurrency || 'SGD' }}</span></td>
                                  </tr>
                                  <tr>
                                    <td class="pl-0">Loading Fee</td>
                                    <td><strong>{{ inputedRates.loadingFee || '-'  }}</strong> <span v-if="inputedRates.loadingFee">{{ inputedRates.loadingFeeCurrency || 'SGD' }}</span></td>
                                  </tr>
                                  <tr>
                                    <td class="pl-0">Event Appearance</td>
                                    <td><strong>{{ inputedRates.eventAppearance || '-'  }}</strong> <span v-if="inputedRates.eventAppearance">{{ inputedRates.eventAppearanceCurrency || 'SGD' }}</span></td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <label>Remark (Instagram)</label>
                            <div>{{ inputedRates.igRemarks || '-'  }}</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-row>
                          <v-col class="d-flex mb-2" cols="12" sm="12" md="12" lg="12">
                            <v-row>
                              <v-col cols="12" sm="12" md="12" lg="12">
                                <v-simple-table class="tiktok-stats" dense>
                                  <template v-slot:default>
                                    <tbody>
                                      <tr>
                                        <td class="pl-0">Tiktok</td>
                                        <td><strong>{{ inputedRates.tiktok || '-'  }}</strong> <span v-if="inputedRates.tiktok">{{ inputedRates.tiktokCurrency || 'SGD' }}</span></td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-col>
                            </v-row>
                            <!-- <label class="mr-2">Tiktok</label>
                            <div><strong>{{ inputedRates.tiktok || '-'  }}</strong> <span v-if="inputedRates.tiktok">$ SGD</span></div> -->
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <label>Remark (TikTok)</label>
                            <div>{{ inputedRates.tiktokRemarks || '-'  }}</div>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <v-divider class="ma-0"></v-divider>
                          </v-col>
                          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
                            <label>Handle of Other Platforms</label>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Platform</th>
                                    <th class="text-left">URL</th>
                                    <th class="text-left">Rate</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr  v-for="(item, index) in inputedRates.platforms" :key="index">
                                    <td>
                                      {{ item.platform }}
                                      <span v-if="item.platform === 'others'">{{item.otherPlatform}}</span>
                                    </td>
                                    <td>{{ item.url }}</td>
                                    <td><strong>{{ item.rate }}</strong> <span v-if="item.rate">{{ item.rateCurrency || 'SGD' }}</span></td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12" v-if="inputedRates.pricingDecks && inputedRates.pricingDecks.length > 0">
                            <label>Media Kit</label>
                            <file-preview :files="inputedRates.pricingDecks" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!--  Commented out old rate card design
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>IG Static</label>
                        <div>{{ (influencer.inputedRates ? (influencer.inputedRates.igStatic ? influencer.inputedRates.igStatic : '-') : '-' ) }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>IG Carousel</label>
                        <div>{{ (influencer.inputedRates ? (influencer.inputedRates.igCarousel ? influencer.inputedRates.igCarousel : '-') : '-' )  }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>IG Story</label>
                        <div>{{ (influencer.inputedRates ? (influencer.inputedRates.igStory ? influencer.inputedRates.igStory : '-') : '-' ) }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>IG Tv</label>
                        <div>{{ (influencer.inputedRates ? (influencer.inputedRates.igTv ? influencer.inputedRates.igTv : '-') : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Tiktok</label>
                        <div>{{ (influencer.inputedRates ? (influencer.inputedRates.tiktok ? influencer.inputedRates.tiktok : '-') : '-') }}</div>
                      </v-col> 
                      <v-col cols="12" sm="12" md="6" lg="6">
                          <label>Blog</label>
                          <div>{{ (influencer.inputedRates ? (influencer.inputedRates.blog ? influencer.inputedRates.blog : '-') : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row v-if="images.length > 0">
                      <v-col cols="12" sm="12">
                        <label>Pricing Decks</label>
                        <div>
                          <v-row>
                            <v-col
                              v-for="(img, index) in images"
                              :key="index"
                              class="d-flex child-flex"
                              cols="12" sm="12" md="3" lg="3"
                            >
                              <v-hover v-slot:default="{ hover }">
                                <v-card
                                  flat
                                  tile
                                  class="d-flex"                              
                                  :elevation="hover ? 16 : 2"
                                >
                                  <v-img                                  
                                    :src="img.url"
                                    :lazy-src="img.url"                                  
                                    class="grey lighten-2"
                                    aspect-ratio="1"
                                  ></v-img>
                                </v-card>
                              </v-hover>
                            </v-col>
                          </v-row>
                          <v-row v-if="decksFiles.length > 0" >
                            <v-col cols="12" sm="12" md="3" lg="3" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                              <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="./static/img/pdf.png"
                                    aspect-ratio="1"
                                  ></v-img>
                              </a>                                                                                                               
                              <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="./static/img/ppt.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="./static/img/doc.png"
                                  ></v-img>
                              </a>
                              <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                <v-img
                                    width="67" height="85"
                                    src="./static/img/text.png"
                                  ></v-img>
                              </a>      
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <label>Remark</label>
                        <div>{{ (influencer.inputedRates ? (influencer.inputedRates.remark ? influencer.inputedRates.remark : '-') : '-') }}</div>
                      </v-col> 
                    </v-row> -->
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">
                    Additional Information
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Gender</label>
                        <div>{{ (userGender_options[influencer.gender] ? userGender_options[influencer.gender] : '-') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>Birthday</label>
                        <div>{{ (influencer.birthday ? influencer.birthday : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <label>{{ isMainPlatform('linkedin') ? 'Followers (Connections)' : 'Followers' }}</label>
                        <div>{{ getSocialMetric('totalFollowers') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="!isMainPlatform('linkedin')">
                        <label>Following</label>
                        <div>{{ getSocialMetric('totalFollowing') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" v-if="influencer.xiaohongshu && influencer.xiaohongshu.xiaohongshu">
                        <label>Total Likes/Favourites</label>
                        <div>{{ (influencer.xiaohongshu ? influencer.xiaohongshu.xiaohongshu.totalLikesFavourites : '-') }}</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs="12" md="12">
                        <label>Preferred type of campaigns/genre</label>
                        <div>
                          <v-chip v-for="(item, index) in formatInfKeywords(influencer.keywords)" :key="index" :value="item"      
                            class="ma-2"                               
                            filter                                                                                                                                                             
                          >
                            {{item}}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
                        <label>About You</label>
                        <div>
                          {{inputedRates.aboutYou || '-'}}
                        </div>
                      </v-col>
                      <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
                        <label style="text-transform:capitalize;font-weight:bold;">{{ (inputedRates.clientType ? inputedRates.clientType : '-') }}</label>
                        <div>
                          {{ (inputedRates.agencyName ? inputedRates.agencyName : '-') }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="title">
                    Travel Information
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6" v-for="(tallyForm, title) in influencer.tallySub" :key="title" v-if="!excludeTitles.includes(title) && tallyForm !== null">
                        <label>{{title}}</label>
                        <div v-if="Array.isArray(tallyForm)">
                          {{tallyForm.join(', ') || '-'}}
                        </div>
                        <div v-else>
                          {{tallyForm || '-'}}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div v-show="isEditMode">
              <edit-influencer-modal
                :influencerData="editInfluencerData"
                :processEdit="processEdit"
                @showLoading="showLoading"
                @closeModal="close"
              />
            </div>
          </v-card-text>
          <!-- </v-container> -->
          <!-- <div class="modal-body row">
            
            <div class="form-group col-xs-12 col-sm-6">
              <label>Keyword be surface for</label>
              <div>{{ influencer.keywords }}</div>
            </div>
              
            
            <div class="form-group col-xs-12 col-sm-6">
              <label>Other social platforms used:</label>
                <ul v-for="(platform, index) in influencer.otherSocialMedias" :key="index">
                  <li>{{platform.label}} <br>{{platform.value}}</li>
                </ul>
            </div>

            <div class="col-xs-12 col-sm-12">
              <b-alert :show="showWordCloudError" dismissible variant="error">
                <h4 class="alert-heading">Couldn't connect to Instagram to display Wordcloud</h4>
                <p>
                This Influencer may not registered with Instagram.
                </p>
              </b-alert>
            </div>

            
            <div class="col-xs-12 col-sm-12" style="height:200px;">
              <center>
                <b-btn v-show="showWordCloudButton" class="btn btn-primary" @click="createInfluencerWordCloud()">Create WordCloud</b-btn>
                <v-progress-circular
                  v-show="loading"
                  color="primary"
                  indeterminate
                ></v-progress-circular>              
              </center>
              <vue-word-cloud
                :v-show="showWordCloud"
                :words="words"
                :color="([,]) => getRandomColor()"
                :rotation="([,]) => getRandomRotation(-1/3, 1/3)"
                font-family="Impact"
              />
            </div>
          </div> -->
        <v-card-actions style="margin-right:20px;" v-if="isViewMode">
          <v-spacer></v-spacer>
          <v-btn class="btn btn-default text--secondary" @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>

<script>
import config from '@/config'
import VueWordCloud from 'vuewordcloud'
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import influencerAPIs from './influencerAPIs'
import EditInfluencerModal from './EditInfluencerModal'
import userAPIs from '../User/userAPIs';
import ViewEditMode from '@/mixins/ViewEditMode'
import Loading from 'vue-loading-overlay';

export default {
  name: 'ViewInfluencerModal',
  props: {
    value: Boolean,
    influencerData: Object
  },
  components: { [VueWordCloud.name]: VueWordCloud, SocialHandle, EditInfluencerModal, Loading },
  mixins: [ViewEditMode],
  data () {
    return {
      userGender_options: {},
      influencer: {
        tiktok: {
          tiktokHandle: '',
          tiktokFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        youtube: {
          youtubeHandle: '',
          youtubeFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        instagram: {
          instagramHandle: '',
          instagramFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        }
      },
      editInfluencerData: null,
      showWordCloud: false,
      words: [],
      loading: false,
      showWordCloudError: false,
      showWordCloudButton: true,
      openExpansion: [0, 1, 2, 3],
      images: [],
      decksFiles: [],
      inputedRates: {
        igStatic: null,
        igCarousel: null,
        igStory: null,
        igTv: null,
        tiktok: null,
        blog: null,
        loadingFee: null,
        remark: '',
        pricingDecks: []
      },
      isLoading: false,
      processEdit: false,
      excludeTitles: [
        'Do you have more travel plan?',
        'Do you still have more travel plan?',
        'respondentId',
        'submissionId'
      ]
    }
  },
  watch: {
    influencerData: function (newInfluencerData) {
      this.influencer = Object.assign({}, newInfluencerData)
      // Retrieve user profile
      this.getUserProfile();
    },
    value(newVal) {
      if (newVal) {
        this.changeMode('view')
      }
    }
  },
  computed: {
    isViewMode: function() {
      return this.currentMode === 'view'
    },
    isEditMode: function() {
      return this.currentMode === 'edit'
    }
  },
  mounted() {
    // Retrieve gender config
    this.userGender_options = {}
    config.userGenderDisplay.forEach(element => {
      this.userGender_options[element.value] = element.text
    })
    this.changeMode('view')
  },
  methods: {
    isMainPlatform(platform) {
      const mainPlatform = String((this.influencer && (this.influencer.activePlatform || this.influencer.platform)) || '').toLowerCase()
      return mainPlatform === platform
    },
    getXiaohongshuData() {
      const xiaohongshu = this.influencer && this.influencer.xiaohongshu
      return xiaohongshu && xiaohongshu.xiaohongshu
        ? xiaohongshu.xiaohongshu
        : xiaohongshu
    },
    getSocialMetric(metric) {
      const facebook = this.influencer && this.influencer.facebook
      const platforms = [
        this.influencer && this.influencer.tiktok,
        this.influencer && this.influencer.youtube,
        this.getXiaohongshuData(),
        facebook && facebook.facebook ? facebook.facebook : facebook,
        this.influencer && this.influencer.linkedin,
        this.influencer && this.influencer.twitter,
        this.influencer && this.influencer.instagram
      ]
      const platform = platforms.find(item => (
        item &&
        typeof item === 'object' &&
        item[metric] !== undefined &&
        item[metric] !== null &&
        item[metric] !== ''
      ))

      return platform ? platform[metric] : '-'
    },
    close() {
      this.$emit('input');
    },
    getUserProfile() {
      this.images = []
      this.decksFiles = []
      this.inputedRates = {}
      if (!this.influencer.userID) {
        return;
      }
      userAPIs
        .getUser(this.influencer.userID)
        .then(response => {
          const profile = response.influencer || {}
          this.influencer = Object.assign({}, this.influencer, {
            bankName: profile.bankName || this.influencer.bankName,
            bankAccount: profile.bankAccount || this.influencer.bankAccount,
            swiftCode: profile.swiftCode || this.influencer.swiftCode,
            country: profile.country || this.influencer.country,
            mailingAddress: profile.mailingAddress || this.influencer.mailingAddress,
            postalCode: profile.postalCode || this.influencer.postalCode
          })
          if (response.influencer.inputedRates) {
            // this.inputedRates = {
            //   igStatic: response.influencer.inputedRates['igStatic'],
            //   igCarousel: response.influencer.inputedRates['igCarousel'],
            //   igStory: response.influencer.inputedRates['igStory'],
            //   igTv: response.influencer.inputedRates['igTv'],
            //   tiktok: response.influencer.inputedRates['tiktok'],
            //   blog: response.influencer.inputedRates['blog'],
            //   loadingFee: response.influencer.inputedRates['loadingFee'],
            //   remark: response.influencer.inputedRates['remark'],
            //   pricingDecks: response.influencer.inputedRates['pricingDecks']
            // }
            this.inputedRates = Object.assign({}, response.influencer.inputedRates)

            // Add pricingDecks images
            if (this.inputedRates.pricingDecks && this.inputedRates.pricingDecks.length > 0) {
              this.inputedRates.pricingDecks.map(item => {
                let mediaType = item.type.split('/')[0];
                if (mediaType === 'image') {
                  this.images.push(item)
                } else {
                  this.decksFiles.push(item)
                  // this.pricingDecksMedia.push(item)
                }
              })
            }
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    createInfluencerWordCloud() {
      // Retrieve user wordcloud
      this.words = []
      this.loading = true
      influencerAPIs.getWordcloud(this.influencerData.id)
        .then(response => {
          this.words = response
          this.showWordCloud = true
          this.loading = false
          this.showWordCloudError = false
        })
        .catch(error => {
          // Request failed.
          console.log('Error in creating wordcloud: ' + error)
          this.showWordCloudError = true
          this.loading = false
          this.showWordCloudButton = false
        })
      this.$on('update:progress', () => {
        console.log('Progress Event')
      })
    },
    getRandomColor: function () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    getRandomRotation: function (min, max) {
      return Math.random() * (max - min) + min
    },
    clearWords() {
      this.showWordCloud = false
      this.words = []
      this.loading = false
      this.showWordCloudError = false
      this.showWordCloudButton = true
    },
    changeModeCustom(mode) {
      if (mode === 'view') {
        this.editInfluencerData = null
      } else {
        this.editInfluencerData = Object.assign({}, this.influencer)
      }
      this.changeMode(mode)
    },
    showLoading(status) {
      this.isLoading = status
    },
    processEdit() {
      this.processEdit = true
    },
    formatInfKeywords(keywords) {
      if (keywords) {
        if (typeof keywords === 'string') {
          return keywords.split(',')
        }
      }
      return keywords
    }
  }
}
</script>
<style scoped>
  .card-title-background {
    background-color: #3F3FFF;
  }
</style>



// WEBPACK FOOTER //
// ViewInfluencerModal.vue?4db2e3f4